// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"45":"da21fb1b","93":"90033d54","716":"971637c9","827":"a8e8a03a","996":"4057f859"}[chunkId] + ".css";
};